import { Outlet } from 'react-router';

export const PublicApp = () => {
  return <Outlet />;
};
